import React from 'react';

export const WHLogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 97 24"
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M37.533 5.055v6.192h-2.357V5.055h-4.785v17.593h4.785v-6.967h2.357v6.967h4.786V5.055h-4.786Z"
      />
      <mask
        id="b"
        width={43}
        height={22}
        x={2}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M7.92 15.083c.007-2.674 3.043-6.002 6.5-7.863 3.17 2.104-.37 10.953-4.365 10.953a1.895 1.895 0 0 1-1.093-.311c1.263-.87 2.578-2.503 3.462-5.51.014-.05.069-.292-.084-.411-.66 2.12-2.068 4.387-3.78 5.542-.478-.612-.64-1.537-.64-2.4M5.314 18.07a11.855 11.855 0 0 1-.067-1.268c0-4.264 3.512-9.375 6.875-9.977-2.948 2.057-4.95 5.25-4.95 8.046 0 1.16.258 2.234.812 2.954a3.788 3.788 0 0 1-1.699.428 2.99 2.99 0 0 1-.97-.183m-3.298-4.068c-.018 1.823.947 3.5 2.49 4.332a7.142 7.142 0 0 0 1.122 3.228c.523.885 1.264 1.253 1.49 1.093-.142-.129-.244-.259-.377-.428-.758-.967-1.204-2.263-1.344-3.53.233.067.474.1.715.103a4.935 4.935 0 0 0 2.256-.574c.423.34.943.516 1.475.502 4.675 0 8.122-9.222 5.174-11.807 2.47-1.192 5.083-1.6 6.918-.482-.477.362-.926.762-1.345 1.196-3.545 3.73-5.194 11.331-7.882 14.381a2.951 2.951 0 0 0-.994-.198c-.534 0-1.023.263-1.09.59-.067.325.31.588.844.588a2.412 2.412 0 0 0 1.345-.426c.288.035.542.114.832.114 1.088 0 2.148-.563 3.336-1.802 3.1-3.26 5.786-10.154 7.61-11.476-1.716 3.032-3.545 9.86-6.035 12.645a2.36 2.36 0 0 0-.955-.228c-.534 0-1.023.263-1.09.589-.066.326.31.589.845.589.498-.008.982-.17 1.392-.467.329.098.668.15 1.01.156.898 0 1.98-.532 2.89-1.487C25.94 17.74 30.093 10.618 33.62 6.906c1.28-1.347 3.578-3.203 6.621-3.203a7.544 7.544 0 0 1 4.692 1.77c.065-.067.041-.186-.11-.34-1.33-1.41-3.133-2.214-5.02-2.238-1.625 0-4.36.593-7.673 4.076-3.535 3.714-7.544 11.161-10.178 13.93-1.105 1.16-1.822 1.422-2.405 1.422a1.476 1.476 0 0 1-.42-.066 14.47 14.47 0 0 0 1.59-1.481c4.317-4.54 5.295-12.876 7.702-15.404-.167-.176-1.343.108-3.413 2.285-3.34 3.511-5.222 9.623-8.501 13.07-1.045 1.09-2.121 1.54-2.801 1.54a1.624 1.624 0 0 1-.4-.054 14.85 14.85 0 0 0 1.516-1.427c2.423-2.548 5.01-10.233 7.836-13.997 3.16-.152 3.113-1.735 2.099-1.735-.57 0-1.395.401-2.207.945-.796-.735-2.147-1.277-4.005-1.277a11.125 11.125 0 0 0-5.505 1.545c-3.614 0-8.604 4.013-8.604 10.784 0 .19.004.378.014.565-.868-.608-1.64-1.718-1.64-3.6C2.807 8.567 10.71 1.952 20.03 1.952c.73.002 1.462.044 2.188.13a18.26 18.26 0 0 1 2.087.366c.66.157 1.31.351 1.947.588.605.225 1.196.488 1.767.794.61.329 1.11.624 1.731 1.204 0 0 .009.008.009.01.04-.159-.07-.312-.159-.427-.253-.327-.61-.594-.936-.842a11.544 11.544 0 0 0-2.07-1.252c-.442-.209-.894-.392-1.354-.553-.52-.181-1.05-.333-1.584-.459a20.007 20.007 0 0 0-3.909-.496A25.308 25.308 0 0 0 18.933 1C10.885 1 2.016 5.948 2.016 14.001Z"
        />
      </mask>
      <g mask="url(#b)">
        <path fill="url(#c)" d="M45 1H2v22h43V1Z" />
      </g>
    </g>
    <defs>
      <linearGradient
        id="c"
        x1={2.466}
        x2={45.417}
        y1={12.023}
        y2={12.023}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCA979" />
        <stop offset={0.01} stopColor="#BCA979" />
        <stop offset={0.71} stopColor="#FCE1A4" />
        <stop offset={1} stopColor="#FCE1A4" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M2 1h43v22H2z" />
      </clipPath>
    </defs>
  </svg>
);
